module.exports = __webpack_public_path__ + "static/media/enactusimage.827f60d2.png";